export default __webpack_public_path__ + "static/media/rocket.9f2cafd9.svg";